import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const FormAfterPreview = ({ documents, emailId }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/questions", {
            state: {
              documents,
              emailId,
              afterPreviewFormFlow: true,
            }
          });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <></>;
}
